/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Run_Cancel_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not cancel the run." |
*
* @param {Agent_Run_Cancel_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_cancel_error = /** @type {((inputs?: Agent_Run_Cancel_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_Cancel_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Lauf konnte nicht abgebrochen werden.")
	return /** @type {LocalizedString} */ ("Could not cancel the run.")
});